'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {Image} from '../Image';
import {AvatarImageView} from './AvatarImageView';

export class AvatarImageComponent extends Component {
  static propTypes = {
    className: T.string,
    iconClass: T.string,
    title: T.string,
    avatarInitials: T.string,
    avatarColor: T.string,
    avatarFontColor: T.string,
    url: T.string,
    displayWidth: T.number,
    displayHeight: T.number,
    targetWidth: T.number,
    targetHeight: T.number,
  };

  static defaultProps = {
    iconClass: 'Avatar__icon',
  };

  render() {
    const props = this.props;
    return (
      <AvatarImageView
        className={props.className}
        iconClass={props.iconClass}
        title={props.title}
        avatarText={props.avatarInitials}
        avatarColor={props.avatarColor}
        avatarFontColor={props.avatarFontColor}
      >
        {props.url ? (
          <Image
            className={props.iconClass}
            title={props.title}
            url={props.url}
            displayWidth={props.displayWidth}
            displayHeight={props.displayHeight}
            crop={true}
            targetWidth={props.targetWidth}
            targetHeight={props.targetHeight}
          />
        ) : null}
      </AvatarImageView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/files/components/AvatarImage/AvatarImageComponent.js